import {
  ApiAttributionModel,
  ApiChartAttribute,
  ApiDimension,
  ApiMetric,
  ApiOperator,
  ApiUserActionUser,
} from "@incendium/api";
import LeadTimelineList from "features/leadAnalytics/components/LeadTimelineList";
import { useCallback, useEffect, useState } from "react";
import Loading from "Components/Loading/Loading";
import { getPrimaryAnalytics } from "../services/analyticsService";
import { metricByAttribution } from "../services/metricFormatter";
import { AttributionMetric } from "../types/types";
import { useLocation } from "react-router-dom";
import { useFromToContext } from "Providers/FromToProvider";
import { CenterPage } from "Components/CenterPage/CenterPage";

interface ILeadsTableProps {
  projectId: number;
  attributes?: ApiChartAttribute[];
  havingAttributionMetric: AttributionMetric;
  havingAttributionModel: ApiAttributionModel;
}

// currently hard coded so only gets leads with attribution values
function LeadsTable({
  projectId,
  attributes,
  havingAttributionMetric,
  havingAttributionModel,
}: ILeadsTableProps) {
  const [leadIds, setLeadIds] = useState<number[]>([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const { chartOutput } = useFromToContext();

  const loadLeads = useCallback(async () => {
    const res = await getPrimaryAnalytics(
      projectId,
      {
        name: "Leads",
        dimension: [ApiDimension.DIMENSION_LEAD_ID],
        yAxisKeys: [
          {
            fields: [ApiMetric.METRIC_NOT_SET],
          },
        ],
        attributes: attributes || [],
        having: [
          {
            metric: metricByAttribution(
              havingAttributionModel,
              havingAttributionMetric,
            ),
            operator: ApiOperator.IS_GREATER_THAN_OR_EQUAL,
            value: 1,
          },
        ],
      },
      chartOutput.from,
      chartOutput.to,
      chartOutput.lastNDays,
    );
    console.log(res, "res");

    setLeadIds(res.chartData.map((d) => Number(d.name)));
    setLoading(false);
  }, [
    attributes,
    havingAttributionModel,
    havingAttributionMetric,
    chartOutput,
    projectId,
  ]);

  useEffect(() => {
    loadLeads();
    return () => {
      setLeadIds([]);
      setLoading(true);
    };
  }, [attributes, loadLeads]);

  const onClick = useCallback(
    (l: ApiUserActionUser, page: number) => {
      const pathParts = location.pathname.split("/");
      const clientIndex = pathParts.indexOf("clients");
      const projectIndex = pathParts.indexOf("projects");

      if (clientIndex !== -1 && projectIndex !== -1) {
        const clientId = pathParts[clientIndex + 1];
        const projectId = pathParts[projectIndex + 1];
        window.open(
          `${window.location.origin}/clients/${clientId}/projects/${projectId}/analyse/standard-reports/user-dashboard/${l.id}?page=${page}`,
          "_blank",
        );
      }
    },
    [location],
  );

  if (loading) {
    return <Loading />;
  }

  if (leadIds.length === 0) {
    return <CenterPage calcHeight>No leads found</CenterPage>;
  }

  return (
    <>
      <LeadTimelineList
        onClick={onClick}
        initialPage={1}
        useParamsPagination={false}
        leadIds={leadIds}
      />
    </>
  );
}

export default LeadsTable;
